/** Use only with Antd Form */
/** Use only with Antd Form */
import { REGEX_REGISTER } from './constant'

/** Currently validator will no longer working if using regex from outside 'validator' object */

const validator = {
  validateAccountTailNumber: (_, input) => {
    const regex = /^(?!.*[0]$)\d+$/
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập từ 3-15 chữ số, không kết thúc bằng 0'))
    } else if (value?.length > 15 || value?.length < 3) {
      return Promise.reject(new Error('Vui lòng nhập từ 3-15 chữ số, không kết thúc bằng 0'))
    } else if (!regex.test(value) || value?.length !== input?.length) {
      return Promise.reject(new Error('Vui lòng nhập từ 3-15 chữ số, không kết thúc bằng 0'))
    } else {
      return Promise.resolve()
    }
  },

  validateDocumentType: (_, value) => {
    if (!value) {
      return Promise.reject(new Error('Vui lòng chọn loại giấy tờ'))
    } else {
      return Promise.resolve()
    }
  },
  validateDocumentNumber: (_, input) => {
    const regex = /^[a-zA-Z0-9\-_/\\]*$/
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập số giấy tờ'))
    } else if (value?.length > 35) {
      return Promise.reject(new Error('Tối đa 35 ký tự'))
    } else if (!regex.test(value)) {
      return Promise.reject(new Error('Chỉ được phép nhập chữ và số, tối đa 35 ký tự, và 1 số ký tự đặc biệt:  - _ / \\'))
    } else {
      return Promise.resolve()
    }
  },
  validateContactName: (_, input) => {
    const regex = /^[a-zA-ZÀ-Ỹ\s,_\-.]+$/
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập tên người liên hệ'))
    } else if (value?.length > 70) {
      return Promise.reject(new Error('Tối đa 70 ký tự'))
    } else if (!regex.test(value)) {
      return Promise.reject(new Error('Được phép nhập chữ hoa, thường, tiếng việt có dấu và các ký tự - _ , .'))
    } else {
      return Promise.resolve()
    }
  },
  validateContactEmail: (_, input) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,}$/
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập email người liên hệ'))
    } else if (value?.length > 35) {
      return Promise.reject(new Error('Tối đa 35 ký tự'))
    } else if (!regex.test(value)) {
      return Promise.reject(new Error('Không đúng định dạng email'))
    } else {
      return Promise.resolve()
    }
  },
  validateContactPhone: (_, input) => {
    const regex = /^0\d{9,10}$/
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập SĐT người liên hệ'))
    } else if (value?.length !== input?.length) {
      return Promise.reject(new Error('Không được chứa khoảng trắng'))
    } else if (!regex.test(value)) {
      return Promise.reject(new Error('Không đúng định dạng SĐT'))
    } else {
      return Promise.resolve()
    }
  },
  validateCity: (_, value) => {
    if (!value) {
      return Promise.reject(new Error('Vui lòng chọn Thành phố'))
    } else {
      return Promise.resolve()
    }
  },


  validateBranch: (_, value) => {
    if (!value) {
      return Promise.reject(new Error('Vui lòng chọn Chi nhánh'))
    } else {
      return Promise.resolve()
    }
  },
  validateReferCode: (_, input) => {
    const regex = /^\d{0,4}$/
    let value = input?.trim()
    if (value?.length !== input?.length) {
      return Promise.reject(new Error('Không được chứa khoảng trắng'))
    } else if (value?.length > 0 && !regex.test(value)) {
      return Promise.reject(new Error('Tối đa 4 ký tự số'))
    } else {
      return Promise.resolve()
    }
  },
  validateCompanyName: (_, input) => {
    const regex = /^[a-zA-ZÀ-Ỹ0-9\s,_\-.]+$/
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập tên doanh nghiệp'))
    } else if (value?.length > 200) {
      return Promise.reject(new Error('Tối đa 200 ký tự'))
    } else if (!regex.test(value)) {
      return Promise.reject(new Error('Được phép nhập chữ hoa, thường, tiếng việt có dấu và các ký tự - _ , .'))
    } else {
      return Promise.resolve()
    }
  },
  validateTaxCode: (_, input) => {
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập mã số thuế'))
    } else if (value?.length > 20) {
      return Promise.reject(new Error('Mã số thuế tối đa 20 ký tự'))
    } else {
      return Promise.resolve()
    }
  },
  validateLegalFullName: (_, input) => {
    const regex = REGEX_REGISTER.LEGAL_FULLNAME
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập tên người liên hệ'))
    } else if (value?.length > 200) {
      return Promise.reject(new Error('Tên người liên hệ không quá 200 ký tự'))
    } else if (!regex.test(value)) {
      return Promise.reject(new Error('Tên người liên hệ không hợp lệ'))
    } else {
      return Promise.resolve()
    }
  },
  validatePhoneNumber: (_, input) => {
    const regex = REGEX_REGISTER.PHONE
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập số điện thoại'))
    } else if (value?.length < 10 || value?.length > 15) {
      return Promise.reject(new Error('Số điện thoại từ 10 đến 15 ký tự'))
    } else if (!regex.test(value)) {
      return Promise.reject(new Error('Số điện thoại không hợp lệ'))
    } else {
      return Promise.resolve()
    }
  },
  validateEmail: (_, input) => {
    const regex = REGEX_REGISTER.EMAIL
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập email'))
    } else if (value?.length > 150) {
      return Promise.reject(new Error('Email tối đa 150 ký tự'))
    } else if (!regex.test(value)) {
      return Promise.reject(new Error('Email không hợp lệ'))
    } else {
      return Promise.resolve()
    }
  },
  validateProvince: (_, input) => {
    if (!input) {
      return Promise.reject(new Error('Vui lòng chọn'))
    } else {
      return Promise.resolve()
    }
  },
  validateDistrict: (_, input) => {
    if (!input) {
      return Promise.reject(new Error('Vui lòng chọn'))
    } else {
      return Promise.resolve()
    }
  },
  validateWards: (_, input) => {
    if (!input) {
      return Promise.reject(new Error('Vui lòng chọn'))
    } else {
      return Promise.resolve()
    }
  },
  validateActivitiesTime: (rule, input, callback) => {
    if (!input) {
      callback('Vui lòng chọn')
    } else {
      callback()
    }
  },
  validateRecentRevenue: (rule, input, callback) => {
    if (!input) {
      callback('Vui lòng chọn')
    } else {
      callback()
    }
  },
  validateCareSolutions: (rule, input, callback) => {
    if (!input || input?.length === 0) {
      callback('Vui lòng tích chọn')
    } else {
      callback()
    }
  },
  validateConfirm: (_, input) => {
    if (!input) {
      return Promise.reject(new Error('Vui lòng tích chọn'))
    } else {
      return Promise.resolve()
    }
  },
}

export default validator
